import { map, prop, values } from 'ramda'

import type { Dishes, Params } from 'app/dataTypes/dishes'
import toFixedValue from 'app/common/lib/toFixedValue'

import type { Request } from '../../index'


const saleTypeMap = (saleTypeId: string | Array<string>) => {
  if (Array.isArray(saleTypeId)) {
    return saleTypeId.map(id => parseInt(id, 10))
  }
  return parseInt(saleTypeId, 10)
}

type ApiParams = {
  sale_type_id?: number | Array<number>
  search?: string
  nomenclature?: string
  limit?: number
  offset?: number
}

export const convertParams = (params: Params): [ApiParams, null] => {
  const { saleTypeId, search, nomenclature, limit, offset } = params
  return [{
    ...(saleTypeId ? { sale_type_id: saleTypeMap(saleTypeId) } : {}),
    ...(search ? { search } : {}),
    ...(nomenclature ? { nomenclature } : {}),
    ...(limit ? { limit } : {}),
    ...(offset ? { offset } : {}),
  }, null]
}

export type ApiResultItem = {
  id: number
  title: string
  photoUrl: string | null
  portion: string
  cost: string
  saleType: {
    id: number
    title: string
  }
  nomenclature: string | null
}

type ApiResult = {
  result: 'success'
  count: number
  items: Record<string, ApiResultItem>
}

export const convertDishItem = ({
  id,
  title,
  photoUrl,
  portion,
  cost,
  saleType,
  nomenclature,
}: ApiResultItem) => ({
  id: String(id),
  title,
  photoUrl: photoUrl || null,
  portion: portion || '',
  cost: toFixedValue(cost),
  saleType: {
    id: String(saleType.id),
    title: saleType.title,
  },
  nomenclature: nomenclature || '',
})

export const convertResult = (data: ApiResult): Dishes => {
  const items = prop('items', data) || {}
  return ({
    total: data.count || 0,
    items: map(convertDishItem, values(items)),
  })
}

export const GET_FOOD_ITEMS: Request<Params, Dishes, void> = [
  'food/items',
  'get',
  ['data'],
]
